import React, { useRef } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./LeadershipTeam.scss";

import imgHimanshu  from "../assets/leader-himanshu.png";
import imgSaurabh   from "../assets/leader-saurabh.png";
import imgShivesh   from "../assets/leader-shivesh.png";
import imgVikram    from "../assets/leader-vikram.png";
import imgDeep      from "../assets/leader-deep.png";
import imgBadoni    from "../assets/leader-badoni.png";
import imgNavinGaur from "../assets/leader-navin-gaur.png";
import imgNavinRai  from "../assets/leader-navin-rai.png";

const FOUNDERS = [
  { img: imgHimanshu, name: "Himanshu Chaurasia", role: "Co-Founder & CEO",  org: "MNNIT Allahabad"  },
  { img: imgSaurabh,  name: "Saurabh Yadav",      role: "Co-Founder & COO", org: "Delhi University" },
];

const ADVISORS = [
  { img: imgShivesh,   name: "Prof. Shivesh Sharma", role: "Academic Advisor",          org: "Dean R&C, MNNIT Allahabad"     },
  { img: imgVikram,    name: "Vikram Joshi",          role: "Academic Advisor",          org: "Ex-Joint Commissioner, NVS"    },
  { img: imgDeep,      name: "Deep Joshi",            role: "Senior Advisor",            org: "Former Member, DST"            },
  { img: imgBadoni,    name: "Dr. GC Badoni",         role: "Academic Advisor",          org: "Founding Member, EMRS"         },
  { img: imgNavinGaur, name: "Navin K Gaur",          role: "Strategic Advisor",         org: "COO, IIITD-IC"                 },
  { img: imgNavinRai,  name: "Navin Krishna Rai",     role: "Corporate Relation Advisor",org: "Senior Manager, IIM Indore"   },
];

export default function LeadershipTeam() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 260, behavior: "smooth" });
  };

  return (
    <section className="lt-wrap">
      <div className="lt-inner">

        {/* ── Header ── */}
        <motion.div
          className="lt__header"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <div className="lt__chip">Our People</div>
          <h2 className="lt__h2">Meet the <span>Leadership Team</span></h2>
          <p className="lt__sub">The people building CoGrad's vision for India's schools.</p>
        </motion.div>

        {/* ── Founders ── */}
        <div className="lt__founders-row">
          {FOUNDERS.map((m, i) => (
            <motion.div
              key={m.name}
              className="lt__founder-card"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, ease: "easeOut", delay: i * 0.07 }}
            >
              <div className="lt__founder-img-wrap">
                <img src={m.img} alt={m.name} className="lt__founder-img" loading="lazy" />
              </div>
              <div className="lt__founder-info">
                <h3 className="lt__founder-name">{m.name}</h3>
                <p className="lt__founder-role">{m.role}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* ── Advisory Board ── */}
        <div className="lt__advisory-header">
          <div className="lt__advisory-label">
            <span>Advisory Board</span>
          </div>
          <div className="lt__scroll-btns">
            <button className="lt__scroll-btn" onClick={() => scroll(-1)} aria-label="Scroll left">
              <ChevronLeft size={18} strokeWidth={2.5} />
            </button>
            <button className="lt__scroll-btn" onClick={() => scroll(1)} aria-label="Scroll right">
              <ChevronRight size={18} strokeWidth={2.5} />
            </button>
          </div>
        </div>

        <div className="lt__advisors-track" ref={scrollRef}>
          {ADVISORS.map((m, i) => (
            <motion.div
              key={m.name}
              className="lt__advisor-card"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, ease: "easeOut", delay: i * 0.05 }}
            >
              <div className="lt__advisor-img-wrap">
                <img src={m.img} alt={m.name} className="lt__advisor-img" loading="lazy" />
              </div>
              <h4 className="lt__advisor-name">{m.name}</h4>
              <p className="lt__advisor-role">{m.role}</p>
              <p className="lt__advisor-org">{m.org}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
